import { FormElementField, useFormField } from 'components/FormElements';

export const TrialFormField = ({
  children,
  customFieldValidation,
  customOnBlur,
  customUserProperty,
  errors = {},
  fieldName,
  fieldType = 'input',
  isUserProperty,
  omitTrackingValue,
  setErrors,
  setFieldValue,
  trackError,
  trackingEventName,
  value,
  ...props
}) => {
  const { handleOnBlur, handleOnChange } = useFormField({
    customFieldValidation,
    customOnBlur,
    customUserProperty,
    errors,
    isSelect: !!props?.selectList,
    isUserProperty,
    fieldName,
    omitTrackingValue,
    setErrors,
    setFieldValue,
    trackError,
    trackingEventName,
  });

  const { [fieldName]: errorMessage } = errors;
  const inputProps = { size: 'md', ...props };

  return (
    <FormElementField
      error={errorMessage}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      value={value}
      {...inputProps}
    />
  );
};

export default TrialFormField;
